import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { YT } from "@/constants/testIds";

export const Header = () => {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    const v = q.trim();
    if (!v) return;
    navigate(`/search?q=${encodeURIComponent(v)}`);
  };

  return (
    <>
      <div className="yt-masthead">
        <Link to="/" className="yt-logo" data-testid={YT.logo}>
          <span className="you">You</span>
          <span className="tube">Tube</span>
        </Link>
        <form onSubmit={onSubmit} className="yt-search-wrap" role="search">
          <input
            type="text"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search"
            className="yt-search-input"
            data-testid={YT.searchInput}
            aria-label="search"
          />
          <button type="submit" className="yt-btn" data-testid={YT.searchBtn}>
            Search
          </button>
        </form>
      </div>
      <div className="yt-navbar">
        <Link to="/" data-testid={YT.navHome}>Home</Link>
        <span className="sep">|</span>
        <Link to="/?sort=popular">Videos</Link>
        <span className="sep">|</span>
        <Link to="/channel" data-testid={YT.navChannel}>Channel</Link>
        <span className="sep">|</span>
        <a href="https://www.youtube.com/@h1t1" target="_blank" rel="noreferrer">
          View on YouTube
        </a>
        <span style={{ marginLeft: "auto", color: "#666" }}>
          Welcome, guest! &nbsp;
          <a href="#">Sign Up</a> | <a href="#">Login</a>
        </span>
      </div>
    </>
  );
};
